import paisii from './images/paisii.png'
import quill from './images/slide3.jpg'
import history_slide from './images/history_slide.jpg'
import popyoanova_cover from './images/pop_yoanova_prepravka_korica.png'
import rilska_cover from './images/rilska_prepravka_korica.png'
import poppunchov_slide1 from './images/poppunchov_slide1.jpg'
import poppunchov_slide2 from './images/poppunchov_slide2.jpg'
import poppunchov_slide3 from './images/poppunchov_slide3.jpg'
import poppunchov_slide4 from './images/poppunchov_slide4.jpg'
import slide4 from './images/slide4.jpg'
import slide6 from './images/slide6.jpg'
import slide7 from './images/slide7.jpg'
import kovanlak_slide from './images/kovanlak_slide.jpg'
import udostoverenie from './images/udostoverenie_fondacia.png'
import el01 from './images/element-01_kovanlashki.png'

import chant from './sound/chant.mp3'

export default {
    paisii, quill, history_slide, 
    popyoanova_cover, rilska_cover, 
    kovanlak_slide, poppunchov_slide1, 
    poppunchov_slide2, poppunchov_slide3, 
    poppunchov_slide4, udostoverenie,
    slide4, slide6, slide7,
    el01, chant
}


// WEBPACK FOOTER //
// ./src/media/index.js